type Props = {
  href: string
  children: React.ReactNode
}

export function IconLink({ href, children }: Props) {
  return <div>{children}</div>
}
